import EmptyState from '../components/EmptyState';

export default function Users() {
  return (
    <EmptyState
      title="Users"
      description="Admin user management and access control"
    />
  );
}
